import { PolicyActionEnum } from '../actions.js';
import { defineBuiltinPolicy } from './types.js';

export const dataScientistPolicy = defineBuiltinPolicy({
  key: 'builtin:data-scientist',
  name: 'Data Scientist',
  description: 'Configure agents, chat contexts, applications and data sources.',
  actions: [
    PolicyActionEnum.ConsoleAccess,
    PolicyActionEnum.AgentView,
    PolicyActionEnum.AgentManage,
    PolicyActionEnum.ApplicationView,
    PolicyActionEnum.ApplicationManage,
    PolicyActionEnum.AuditLogView,
    PolicyActionEnum.BrandView,
    PolicyActionEnum.ChatContextView,
    PolicyActionEnum.ChatContextManage,
    PolicyActionEnum.DataSourceView,
    PolicyActionEnum.DataSourceManage,
    PolicyActionEnum.PromptQueryLogView,
    PolicyActionEnum.SecretView,
    PolicyActionEnum.SecretManage,
    PolicyActionEnum.TerminologyView,
    PolicyActionEnum.UserView,
  ],
});
